import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from "@mui/material";
import {IConfSecuencia} from "../../redux/types/ICompania";

export default function Secuencias({values,onChange}:{values:IConfSecuencia[],onChange:(secuencias:IConfSecuencia[])=>void} ){
    const handleChange = (item:IConfSecuencia) => {
        let lista = values.map(v=>{
            if(v.id === item.id){
                return item
            }
            return v
        });
        onChange(lista);
    };
    return(
            <TableContainer>
                <Table size={"small"}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Tipo Documento</TableCell>
                            <TableCell>Prefijo</TableCell>
                            <TableCell>Longitud</TableCell>
                            <TableCell>Secuencia Siguiente</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {values.map((item)=>
                            <TableRow key={item.id}>
                                <TableCell>{item.tipoDocumentoString}</TableCell>
                                <TableCell>
                                    <TextField  size={"small"}  inputProps={{maxLength:10}} value={item.prefijo ?? ""}
                                               onChange={({target})=>handleChange({...item, prefijo: target.value})}/>
                                </TableCell>
                                <TableCell>
                                    <TextField type={"number"} size={"small"}  value={item.longitud ?? ""}
                                               onChange={({target})=>handleChange({...item, longitud: target.value? parseInt(target.value):undefined})}/>
                                </TableCell>
                                <TableCell>
                                    <TextField type={"number"} size={"small"} value={item.secuenciaSiguiente ?? ""}
                                               onChange={({target})=>handleChange({...item,secuenciaSiguiente: target.value? parseInt(target.value):undefined})}/>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

    )
}
